import { useMutation, useQueryClient } from '@tanstack/react-query';
import { put } from '@truefit/http-utils';
import { useEffect } from 'react';
import getCurrentUserQuery from './getCurrentUser';
import { useLDClient } from 'launchdarkly-react-client-sdk';
import identifyUser from '@/features/authentication/functions/identifyUser';

interface UpdateSessionData {
  org?: number;
  league?: number;
}

export const useUpdateSession = () => {
  const queryClient = useQueryClient();
  const getCurrentUser = getCurrentUserQuery();
  const ldClient = useLDClient();

  useEffect(() => {
    if (getCurrentUser.status === 'success') {
      const { data: { data: { user: { email, group } } } } = getCurrentUser;
      
      
      identifyUser(email, email, ldClient, group);
    }
  }, [getCurrentUser.status])

  return useMutation({
    mutationFn: async (data: UpdateSessionData) => {
      const response = await put<UpdateSessionData>('/v1.0/session', data);
      return response.data;
    },
    onSuccess: () => {
      // refetchQueries bypasses 'enabled: false' and forces an immediate fetch,
      // ensuring the UI reflects the new session context (org/league) right away.
      queryClient.refetchQueries({ queryKey: ['User'] });
      queryClient.invalidateQueries({ queryKey: ['GameTeams'] });
      queryClient.invalidateQueries({ queryKey: ['AllUsers'] });
      queryClient.invalidateQueries({ queryKey: ['Games'] });
      queryClient.invalidateQueries({ queryKey: ['Seasons'] });
      // Also invalidate v1.1 game queries (lowercase keys from gameQueries.ts)
      queryClient.invalidateQueries({ queryKey: ['games'] });
      queryClient.invalidateQueries({ queryKey: ['previousGames'] });
      queryClient.invalidateQueries({ queryKey: ['nextGames'] });
      queryClient.invalidateQueries({ queryKey: ['gameDates'] });
      queryClient.invalidateQueries({ queryKey: ['clips'] });
      // ['org'] is keyed without orgId; must be invalidated on org switch
      // or stale departments/org payload leak into the new org's UI.
      queryClient.invalidateQueries({ queryKey: ['org'] });
    },
  });
};

export default useUpdateSession;
